const PHRASES = [
  "High Trust",
  "Tough Processes",
  "No Secret Zones",
  "Truth First",
  "Random Deep-Dives",
  "Whistleblowers Championed",
  "Daylight Always",
];

export const Marquee = ({ dark = false }) => {
  const items = [...PHRASES, ...PHRASES];
  return (
    <div
      data-testid="marquee"
      className={`relative overflow-hidden py-6 marquee-mask border-y ${
        dark ? "bg-ink border-ivory/10" : "bg-white border-ink/10"
      }`}
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((p, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-serif text-2xl md:text-3xl px-8 ${
                dark ? "text-ivory/85" : "text-ink/80"
              }`}
            >
              {p}
            </span>
            <span className="text-windsor text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
